const externalUrl = (
  value: string | undefined,
  fallback: string,
  label: string,
) => {
  const candidate = value?.trim() || fallback;
  let parsed: URL;

  try {
    parsed = new URL(candidate);
  } catch {
    throw new Error(`Invalid ${label}: ${candidate}`);
  }

  if (!["http:", "https:"].includes(parsed.protocol)) {
    throw new Error(`Invalid ${label} protocol: ${candidate}`);
  }

  return parsed.toString();
};

const generalSalesUrl = externalUrl(
  import.meta.env.VITE_SAILPLOT_SALES_URL,
  "https://heiselanalytics.one/",
  "SailPlot sales URL",
);

/** External destinations for the public SailPlot customization page. */
export const customizationSalesLinks = Object.freeze({
  configurator: externalUrl(
    import.meta.env.VITE_SAILPLOT_CONFIGURATOR_URL,
    "https://config.sailplot.app/",
    "SailPlot configurator URL",
  ),
  liveExample: externalUrl(
    undefined,
    "https://example.sailplot.app/",
    "SailPlot live example URL",
  ),
  personalCoach: externalUrl(
    import.meta.env.VITE_SAILPLOT_PERSONAL_COACH_URL,
    generalSalesUrl,
    "Personal, Coach & Sailing Team sales URL",
  ),
  clubCompany: externalUrl(
    import.meta.env.VITE_SAILPLOT_CLUB_COMPANY_URL,
    generalSalesUrl,
    "Club & Company sales URL",
  ),
  enterprise: externalUrl(
    import.meta.env.VITE_SAILPLOT_ENTERPRISE_URL,
    generalSalesUrl,
    "Enterprise contact URL",
  ),
});
